import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../store/useAuthStore'

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, profile, loading } = useAuthStore()
  const location = useLocation()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(profile?.role)) {
    // Redirect to appropriate dashboard based on user role
    if (profile?.role === 'admin') {
      return <Navigate to="/admin" replace />
    } else if (profile?.role === 'employee') {
      return <Navigate to="/employee" replace />
    } else if (profile?.role === 'client') {
      return <Navigate to="/client" replace />
    } else {
      return <Navigate to="/unauthorized" replace />
    }
  }

  return children
}

export default ProtectedRoute
